import type { Cvpartner } from "@/shared/bootstrap/cvpartner.ts";
import { invariant } from "@/shared/util/invariant.ts";

export function getCvPartner(): Cvpartner {
  const cvpartner = (window as unknown as { cvpartner?: Cvpartner }).cvpartner;
  invariant(cvpartner, "CVPartner is not initialized");
  return cvpartner;
}

export function skipFetchingUser(pathname = window.location.pathname) {
  const isOnLoginPage = pathname === "/login";
  const isOnAdminLoginPage = pathname === "/login/admin";
  const isOnOtpPage = pathname === "/login/otp";
  const isOnSignedOutPage = pathname === "/login/signed_out";

  return (
    isOnLoginPage || isOnAdminLoginPage || isOnOtpPage || isOnSignedOutPage
  );
}
